import { render, staticRenderFns } from "./HarvestYearTimelineLabel.vue?vue&type=template&id=6c2028c5&scoped=true&lang=html&"
import script from "./HarvestYearTimelineLabel.vue?vue&type=script&lang=js&"
export * from "./HarvestYearTimelineLabel.vue?vue&type=script&lang=js&"
import style0 from "./HarvestYearTimelineLabel.vue?vue&type=style&index=0&id=6c2028c5&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c2028c5",
  null
  
)

export default component.exports